/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, flatMap } from 'rxjs/operators';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';


@Injectable()
export class ContractDetailsPDFService {
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService
  ) { }

  getCoverageDocument(contractNumber, clientId, trackingId, associateNumber): Observable<any> {
    const subscriptionKey = this.preInitSettingsService.getSettings().middleWare.subscriptionKey;
    const contractPdf = this.preInitSettingsService.getSettings().middleWare.contractPdfEndPoint;
    const middleWareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;


    const httpOptions = {
      params: new HttpParams()
        .set('contractId', contractNumber)
        .set('clientId', clientId)
        .set('trackingId', trackingId)
        .set('associateNumber', associateNumber)
    };

    return this.http
      .get(`${middleWareUrl}${contractPdf}`, httpOptions);
  }
}
